import React from 'react';
import styled from "styled-components";
import { AutomationPlacement, AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';
import Picture from '../Picture';

const AdvisorContainer = styled.div`
    .card-body h2 a {
        text-decoration: none;
        color:#000;
    }

    .card-body h2 a:hover {
        text-decoration: underline;
    }

    .card-body p a {
        text-decoration: none;
        color:#000;
    }

    .card-body p a:hover {
        text-decoration: underline;
    }
`;

export default function Advisor(props) {
    const { name, title, number, picture, bio, custom_one, custom_two } = props;
    const pictureUrl = picture.match(/^https/) ? picture : `${process.env.GATSBY_MEDIA_URL}${picture.replace(/^\/?media/, '')}`;
    return (
        <AdvisorContainer className="col col-sm-12 col-md-6 col-lg-3 py-4" data-test-id={createDataTestId({feature: AutomationTestIdFeature.WEALTH_ADVISOR_LOOKUP, element: AutomationTestIdElementType.COLLECTION_ITEM})}>
            <div className="card border-0 rounded-0 bg-gray-200 h-100">
                <a href={bio} data-test-id={createDataTestId({feature: AutomationTestIdFeature.WEALTH_ADVISOR_LOOKUP, element: AutomationTestIdElementType.LINK, specifier: 'image'})}>
                    <Picture loading="lazy" data-test-id={createDataTestId({feature: AutomationTestIdFeature.WEALTH_ADVISOR_LOOKUP, element: AutomationTestIdElementType.IMAGE})} alt={name} src={pictureUrl} style={{maxWidth: "100%"}} className="ae-img" />
                </a>
                <div className="card-body p-4">
                    <h5 className="text-muted">{title}</h5>
                    <h2><a href={bio} data-test-id={createDataTestId({feature: AutomationTestIdFeature.WEALTH_ADVISOR_LOOKUP, element: AutomationTestIdElementType.LINK, specifier: 'name'})}>{name}</a></h2>
                    {custom_one && <p>{custom_one}</p>}
                    {number && <p><strong><a href={`tel:${number}`}>{number}</a></strong></p>}
                </div>
                {custom_two && <div className="card-footer border-0 px-4 pb-4 pt-0">
                    <button
                        data-delay="1" data-height="640" data-psz="00" data-so-page={custom_two} id={`SOIBTN_${custom_two}`}
                        className="btn btn-primary w-100">Schedule an appointment</button>
                </div>}
            </div>
        </AdvisorContainer>
    );
};
